/**
 * @description 图表组件=>去除图形,展示班级信息title组件 2021-1-5 
 * @author xyguo
 * @date 2020-3-6
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import { component_tool, framework_tool, utils_tool } from '@/tool'
import { WizButton, WizCol, WizModal, WizRow } from 'wiz-components'
import {ChapterPreview, LookPreview, BankQuestionLook} from '../../../online'
let {
  WizCard,
  WizBizcharts
} = component_tool;
let { WizContainer } = framework_tool;

class ExamInfo extends WizContainer {

  componentName = 'ExamInfo';

  constructor(props) {
    super(props);
    this.state = {
      questionId: props.record.questionId,
      lookBankQUestionVisible: false,
      answer:props.record.answer
    }
  }

  _componentDidMount() {

  }


  propsAndStateOnChange = {
  }




  _showQuestion() {
    this.setState({
      lookBankQUestionVisible: true
    })
  }

  _render() {
    const { examName, examDate } = this.props.record;
    const { questionId,lookBankQUestionVisible,answer } = this.state;
    let record = { id: questionId }
    let content = <WizRow>
      <WizCol span={12}>
        考试名称: {examName}
      </WizCol>
      <WizCol span={12}>
        考试时间: {examDate}
      </WizCol>
    </WizRow>
    let errorAnswer = answer || answer==""?
    <WizCol span={12}>
      错误答案: {answer}
    </WizCol> :<></>
    let question = questionId ? <WizRow style={{ marginTop: 20 }}>
      <WizCol span={12}>
        题目内容: <WizButton type='primary' style={{ height: '80%' }} onClick={e => this._showQuestion()}>查看</WizButton>
      </WizCol>
       {errorAnswer}
    </WizRow> : <></>
    return [
      <WizCard title={'考试信息'} key={examName+questionId} bodyStyle={{ paddingLeft: 20, paddingBottom: 25, paddingTop: 25 }}>
        {content}{question}
        <WizModal destroyOnClose
          footer={null}
          key={questionId}
          width={700} title={"题目预览"}
          visible={lookBankQUestionVisible}
          // onOk={() => {this.setState({lookBankQUestionVisible: false})}}
          onCancel={() => {
            this.setState({ lookBankQUestionVisible: false })
          }}
        >
          <BankQuestionLook record={record}
            key={questionId}

            changeModal={() => {
              this.setState({ lookBankQUestionVisible: false })
            }} 
            />
        </WizModal>
      </WizCard>
    ]
  }
}

const mapStateToProps = (state, ownProps) => {
  const { bankQuestion } = state;
  const bankQuestionInfo = modelUtils.getModelEntity(bankQuestion, "bankQuestion@bankQuestionInfo");
  const load = modelUtils.getLoadingState(state, ['bankQuestion'])
  return {
    bankQuestionInfo,
    ...load
  };
};

export default connect(mapStateToProps)(ExamInfo);
